<template>
  <div class="subscription-card-qa-wrapper">
    <!-- BUSINESS OWNER -->
    <CalicoSubscriptionCard
      :tier="SubscriptionCopy.PLANS.BUSINESS_OWNER.title"
      :info-cards="[
        { label: SubscriptionCopy.LABEL.ANNUAL, content: '$10' }
      ]"
      :features="SubscriptionCopy.PLANS.BUSINESS_OWNER.features"
      :billing-label="SubscriptionCopy.LABEL.NEXT_BILLING"
      next-billing-date="$10 on February 7, 2026"
      :buttons="[
        {
          label: SubscriptionCopy.BUTTON.MANAGE_SUBSCRIPTION.label,
          variant: 'primary',
          event: SubscriptionCopy.BUTTON.MANAGE_SUBSCRIPTION.event
        }
      ]"
    />

    <!-- TRIAL -->
    <CalicoSubscriptionCard
      :tier="SubscriptionCopy.PLANS.TRIAL.title"
      :info-cards="[
        { label: '7 Days', content: '$0' }
      ]"
      :features="SubscriptionCopy.PLANS.TRIAL.features"
      :billing-label="SubscriptionCopy.LABEL.TRIAL_ENDS"
      next-billing-date="February 7, 2026"
      :buttons="[
        {
          label: SubscriptionCopy.BUTTON.UPGRADE.label,
          variant: 'primary',
          event: SubscriptionCopy.BUTTON.UPGRADE.event
        },
        {
          label: SubscriptionCopy.BUTTON.MANAGE.label,
          variant: 'secondary',
          event: SubscriptionCopy.BUTTON.MANAGE.event
        }
      ]"
    />

    <!-- PAY AS YOU GO -->
    <CalicoSubscriptionCard
      :tier="SubscriptionCopy.PLANS.PAY_AS_YOU_GO.title"
      :info-cards="[
        { label: SubscriptionCopy.LABEL.PER_MONTH, content: 3 }
      ]"
      :features="SubscriptionCopy.PLANS.PAY_AS_YOU_GO.features"
      :billing-label="SubscriptionCopy.LABEL.LAST_PURCHASE"
      next-billing-date="January 10, 2026"
      :buttons="[
        {
          label: SubscriptionCopy.BUTTON.UPGRADE.label,
          variant: 'primary',
          event: SubscriptionCopy.BUTTON.UPGRADE.event
        },
        {
          label: SubscriptionCopy.BUTTON.MANAGE.label,
          variant: 'secondary',
          event: SubscriptionCopy.BUTTON.MANAGE.event
        }
      ]"
    />

    <!-- STARTER  -->
    <CalicoSubscriptionCard
      :tier="SubscriptionCopy.PLANS.STARTER.title"
      :info-cards="[
        { label: SubscriptionCopy.LABEL.PER_MONTH_PER_SEAT, content: '$49' }
      ]"
      :features="SubscriptionCopy.PLANS.STARTER.features"
      :billing-label="SubscriptionCopy.LABEL.NEXT_BILLING"
      next-billing-date="February 28, 2026"
      :buttons="[
        {
          label: SubscriptionCopy.BUTTON.MANAGE.label,
          variant: 'primary',
          event: SubscriptionCopy.BUTTON.MANAGE.event
        }
      ]"
    />

    <!-- CORE -->
    <CalicoSubscriptionCard
      :tier="SubscriptionCopy.PLANS.CORE.title"
      :info-cards="[
        { label: SubscriptionCopy.LABEL.PER_MONTH_PER_SEAT, content: '$1,500' },
        { label: SubscriptionCopy.LABEL.SEATS, content: 3 }
      ]"
      :features="SubscriptionCopy.PLANS.CORE.features"
      :billing-label="SubscriptionCopy.LABEL.NEXT_BILLING"
      next-billing-date="$4,500.00 on February 28, 2026"
      :buttons="[
        {
          label: SubscriptionCopy.BUTTON.UPGRADE.label,
          variant: 'primary',
          event: SubscriptionCopy.BUTTON.UPGRADE.event
        },
        {
          label: SubscriptionCopy.BUTTON.ADD_SEATS_MANAGE.label,
          variant: 'secondary',
          event: SubscriptionCopy.BUTTON.MANAGE.event
        }
      ]"
    />
  </div>
</template>

<script>
import CalicoSubscriptionCard from '@/components/calico/subscriptionCard/index.vue'
import { SubscriptionCopy } from '@/enums'

export default {
  name: 'SubscriptionCardPage',
  components: {
    CalicoSubscriptionCard,
  },
  data() {
    return {
      SubscriptionCopy
    }
  }
}
</script>

<style scoped lang="scss">
.subscription-card-qa-wrapper {
  display: flex;
  flex-direction: column;
  gap: $space-xlarge;
  padding: $space-xlarge;
  max-width: 720px;
  margin: 0 auto;
}
</style>